import { Link } from '@reach/router';
import styled from 'styled-components/macro';
import {
  focusRing,
  fontSize,
  lineHeight,
  neutral,
  radius,
  space,
} from '../../../theme/tokens';
import { StaffSubHeader } from '../../common/elements/Staff';

export const AssessmentLink = styled(Link)`
  display: block;
  text-decoration: none;
  color: inherit;
  border-radius: ${radius.md};
  ${focusRing}
`;

export const AssessmentTitle = styled(StaffSubHeader)`
  padding: 0;
  overflow-wrap: anywhere;
`;

export const AssessmentInfo = styled.p`
  margin: ${space[2]} 0 0;
  font-size: ${fontSize.md};
  line-height: ${lineHeight.normal};
  color: ${neutral.textMuted};
`;

export * from '../../common/elements/Staff';
